const toPositiveMoney = (value) => {
    const amount = Number(value);
    return Number.isFinite(amount) && amount > 0 ? amount : undefined;
};
const normalized = (value) => String(value ?? '')
    .trim()
    .toLowerCase();
const isTrueLike = (value) => value === true || normalized(value) === 'true';
const hasPositiveAmount = (value) => toPositiveMoney(value) !== undefined;
/**
 * Reserved season invoices were sometimes left complimentary=true after the
 * hold was billed. Those rows still carry the Stripe processing fee on
 * processingFee and details.pricing. A true comp has no positive total.
 */
const isBilledDespiteComplimentaryFlag = (order) => {
    if (!isTrueLike(order.complimentary))
        return false;
    const hasRevenue = [order.total, order.gross, order.amountDue].some(hasPositiveAmount);
    if (!hasRevenue)
        return false;
    return [
        order.processingFee,
        order.estimatedProcessingFee,
        order.details?.pricing?.processingFee,
        order.details?.pricing?.paymentProcessingFee,
    ].some(hasPositiveAmount);
};
/**
 * Resolve the customer-facing processing fee used to derive receipt subtotal.
 *
 * Some POS assignment orders historically stored estimatedProcessingFee=0
 * because paymentOption "in-person" was classified as cash, even though their
 * checkout pricing snapshot contains the processing fee charged to the buyer.
 */
export function getInvoiceProcessingFee(order) {
    if (!order)
        return 0;
    const paymentValues = [
        order.paymentType,
        order.paymentOption,
        order.paymentMethodType,
        order.details?.paymentMethod,
    ].map(normalized);
    if (isTrueLike(order.voucher) ||
        (isTrueLike(order.complimentary) &&
            !isBilledDespiteComplimentaryFlag(order)) ||
        paymentValues.includes('voucher') ||
        paymentValues.includes('comp')) {
        return 0;
    }
    return (toPositiveMoney(order.estimatedProcessingFee) ??
        toPositiveMoney(order.details?.pricing?.processingFee) ??
        toPositiveMoney(order.processingFee) ??
        0);
}
